import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ICourse } from '@interfaces/ICourse';
import { UserInfoLoadingForTabs } from '@myStore/users/user.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CoursesService } from '@services/courses/courses.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';
import { IAppState } from '../app.state';
import {
  ECoursesActions,
  GetCourses,
  GetCoursesSuccess,
} from './courses.actions';

@Injectable()
export class CoursesEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _coursesService: CoursesService,
    private _router: Router,
    private _toastr: ToastrService,
    private _location: Location
  ) {}

  $getCourses = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetCourses>(ECoursesActions.GetCourses),
        switchMap(() => {
          return this._coursesService.getCourses().pipe(
            map((courses: ICourse[]) => {
              this._store.dispatch(new GetCoursesSuccess(courses));
              this._store.dispatch(new UserInfoLoadingForTabs(false));
            }),
            catchError(err => {
              this._store.dispatch(new UserInfoLoadingForTabs(false));
              this._toastr.error(
                `${err?.error?.detail}`,
                'При получении курсов возникла ошибка',
                {
                  timeOut: 3500,
                }
              );
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
